import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { search } from "../redux/userRedux";
import theme from "../theme";
import { IconSearch } from "../icons";
import NotificationBell from "./NotificationBell";

const Bar = styled.header`
  height: 56px;
  background: ${theme.bg};
  border-bottom: 1px solid ${theme.separator};
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0 28px;
  gap: 16px;
  position: sticky;
  top: 0;
  z-index: 50;
`;

const SearchForm = styled.form`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 420px;
  justify-self: center;
`;

const SearchIconWrap = styled.span`
  position: absolute;
  left: 12px;
  color: ${theme.textMuted};
  display: flex;
  align-items: center;
  pointer-events: none;
`;

const SearchInput = styled.input`
  width: 100%;
  background: ${theme.cardBg};
  border: 1.5px solid ${theme.cardBorder};
  border-radius: 22px;
  padding: 8px 16px 8px 36px;
  font-size: 13px;
  font-family: inherit;
  color: ${theme.textMain};
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;

  &::placeholder { color: ${theme.textMuted}; }
  &:focus {
    border-color: ${theme.primary};
    box-shadow: 0 0 0 3px ${theme.primaryGlow};
  }
`;

const RightIcons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
`;

const FeedLabel = styled.span`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: ${theme.primary};
  text-transform: uppercase;
  padding: 0 4px;
`;

export default function Navbar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector((s) => s.user.currentUser);
  const [query, setQuery] = useState("");

  const handleSearch = (e) => {
    e.preventDefault();
    if (query.trim()) {
      dispatch(search(query.trim()));
      navigate("/searchuser");
    }
  };

  return (
    <Bar>
      <div />
      <SearchForm onSubmit={handleSearch}>
        <SearchIconWrap><IconSearch size="14px" /></SearchIconWrap>
        <SearchInput
          type="text"
          placeholder="Search the users..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </SearchForm>
      <RightIcons>
        {currentUser && <NotificationBell />}
        <FeedLabel>Feed</FeedLabel>
      </RightIcons>
    </Bar>
  );
}
